module.exports = __webpack_public_path__ + "static/media/user_icon.5faa6a17.svg";